// import { Card, Stack, Table, Title } from "@mantine/core";
import { WALLET_ASSETS_USER_QUERY } from '../../../queries/OrdersAndWallets'
import React, { useState, useEffect } from "react";
import { useQuery } from '@apollo/client'
import AssetTableGenerator from "../AssetTableGenerator/AssetTableGenerator";

export default function AssetsTable({ walletid }) {
	const [walletAssets, setWalletAssets] = useState([]);
	const { loading: queryloading, error: queryError, data: queryData, refetch } = useQuery(WALLET_ASSETS_USER_QUERY, { 
		variables: { walletid } 
	});

	console.log("QD ", queryData)

	useEffect(() => {
		try {
			if (queryData !== undefined && queryData.getWalletAssetsWalletID) {
				const res = queryData.getWalletAssetsWalletID
				const R2 = res.map(({ symbol, amount, locked, ...del_attrs }) => ({ symbol: symbol.substring(0, 3).toUpperCase(), amount, locked }))
				setWalletAssets(R2);
			}
			refetch();
		} catch (error) { }
	}, [walletid, queryloading, queryError, queryData, refetch])

	if (walletAssets.length) return (<AssetTableGenerator DataObject={walletAssets} title={"My Portfolio"} />)
	else return (<div>NO ASSETS TO DISPLAY</div>)
}